(function () {
  function init(root) {
    if (!(root instanceof HTMLElement)) return;
    const items = root.querySelectorAll(".parans-category-header__item--mega");

    function closeAll() {
      items.forEach(function (item) {
        item.classList.remove("is-open");
        const t = item.querySelector(".parans-category-header__trigger");
        if (t instanceof HTMLElement) t.setAttribute("aria-expanded", "false");
      });
    }

    // 是否给鼠标悬浮交互(桌面)。注意:很多触屏设备 / 二合一也会报 hover:hover,
    // 所以"点击是开关还是仅打开"不能只看 matchMedia,要看**真实指针类型**(见 lastPointerType)。
    var hoverCapable = !!(window.matchMedia && window.matchMedia("(hover: hover)").matches);

    // 记录最近一次按下的指针类型(touch / pen / mouse)。触摸点击 → 开/关切换;
    // 鼠标 → 仅打开(关闭交给 mouseleave)。这样即使设备误报 hover:hover,手指点击也能正常收起。
    var lastPointerType = "mouse";
    document.addEventListener("pointerdown", function (e) {
      if (e.pointerType) lastPointerType = e.pointerType;
    }, true);
    function isTouchLike() { return lastPointerType === "touch" || lastPointerType === "pen"; }

    function openOnly(item, trigger) {
      closeAll();
      item.classList.add("is-open");
      trigger.setAttribute("aria-expanded", "true");
    }
    function closeItem(item, trigger) {
      item.classList.remove("is-open");
      trigger.setAttribute("aria-expanded", "false");
    }

    items.forEach(function (item) {
      const trigger = item.querySelector(".parans-category-header__trigger");
      if (!(trigger instanceof HTMLElement)) return;
      var closeTimer = null;

      trigger.addEventListener("click", function (event) {
        event.preventDefault();
        var photo = event.target instanceof Element && event.target.closest(".parans-category-header__photo");
        var categoryUrl = trigger.getAttribute("data-category-url");
        if (photo && categoryUrl) {
          window.location.assign(categoryUrl);
          return;
        }
        if (isTouchLike()) {
          // 触摸:点击 = 开/关切换(再点同一个收起)
          if (item.classList.contains("is-open")) closeItem(item, trigger);
          else openOnly(item, trigger);
          return;
        }
        // 鼠标:点击 = 确保打开(关闭交给鼠标移开)
        openOnly(item, trigger);
      });

      // 桌面端鼠标:悬浮即展开,移开延迟收起(mega 面板在同一 <li> 内,跨空隙不误关)。
      // 触摸时这两个会被合成触发,故用 isTouchLike() 跳过,避免和点击切换打架。
      if (hoverCapable) {
        item.addEventListener("mouseenter", function () {
          if (isTouchLike()) return;
          if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
          openOnly(item, trigger);
        });
        item.addEventListener("mouseleave", function () {
          if (isTouchLike()) return;
          // 触发块与面板之间隔着 ~12px 空隙,鼠标穿过会瞬间 mouseleave;延迟关闭让指针有时间抵达面板,
          // 进入 <li> 子树会触发 mouseenter 清掉定时器 → 不关闭。
          if (closeTimer) clearTimeout(closeTimer);
          closeTimer = setTimeout(function () {
            closeItem(item, trigger);
            closeTimer = null;
          }, 280);
        });
      }

      item.addEventListener("focusout", function () {
        requestAnimationFrame(function () {
          if (!item.contains(document.activeElement)) {
            item.classList.remove("is-open");
            trigger.setAttribute("aria-expanded", "false");
          }
        });
      });
    });

    document.addEventListener("click", function (event) {
      items.forEach(function (item) {
        if (event.target instanceof Node && !item.contains(event.target)) {
          item.classList.remove("is-open");
          const t = item.querySelector(".parans-category-header__trigger");
          if (t instanceof HTMLElement) t.setAttribute("aria-expanded", "false");
        }
      });
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeAll();
      }
    });
  }

  document.querySelectorAll("[data-parans-category-header]").forEach(init);
})();
